import { render } from "./ToggleSimple.vue?vue&type=template&id=aed3e05c"
import script from "./ToggleSimple.vue?vue&type=script&lang=js"
export * from "./ToggleSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__